<script>
    import appConfig from '@src/app.config'
	import Layout from '@layouts/newdefaultform'
	import PageHeader from '@components/page-header'
	import listManage from '@components/list-manage'
    import Confirmation from '@components/confirmation'
	import Spinner from '@components/spinner'  
	import { giftlistApi } from '@router/apiFiles/giftlistApi'
	import { reportsApi } from '@router/apiFiles/reportsApi'
	import { productApi } from '@router/apiFiles/productApi'

    /**
     * Page
     */
    export default {
        page: {
            title: 'Presentes recebidos',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout, PageHeader, listManage, Confirmation, Spinner
        },
        data() {
            return {
                title: 'Presentes recebidos',
                items: [
                    {
                        text: 'LaVille',
                        href: '/',
                    },
                    {
                        text: 'Listas',
                        href: '/',
                    },
                    {
                        text: 'Presentes recebidos',
                        active: true,
                    },
				],
                id: '',
                externalId: '',
                gifts: '',
                isBusy: false
            }
        },
        mounted() {
            this.fetchData()
        },
        methods: {
            async fetchData() {
                var self = this;
                self.isBusy = true;
				giftlistApi
					.getGiftlistByUrl({ url: self.$route.params.urlText })
					.then(function(data) {
                        self.id = data.data.id;
                        self.externalId = data.data.externalId;
						reportsApi.GetGiftsFromList({ giftlistId: self.id }).then(function(data) {                            
                            var gifts = data.data;
                            self.gifts = [];
                            self.isBusy = false;
                            gifts.forEach((item, index) => {
                                item.order = {};
                                item.items = [];
                                self.gifts.push(item);
                                reportsApi.GetGift({ orderNumber:item.number }).then(function(data) {
                                    item.order = data;
                                    if (item.note == '' || item.note == null) item.note = data.note;
                                    var products = data.items;
                                    products.forEach((product, productindex) => {
                                        productApi.GetProduct({ skuid: product.id }).then(function(data) {
                                            if (data != null && data.data != null) {
                                                product.imageUrl = data.data.imageUrl;
                                                item.items.push(product);
                                            }
                                        });
                                    });
                                });
                            });
						});
					});			
			},
        }
    }
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="row">			
			<div class="col-md-8 offset-md-2">
				<div class="card">
					<div class="card-header custom">
					</div>
					<div class="card-body pt-2 pb-2">

						<h5 class="mb-4 header-title">Presentes recebidos</h5>
						
                        <Spinner :loading="isBusy" />

						<div v-for="(gift, giftindex) in gifts" v-bind:key="giftindex">
                            <div class="card border">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="w-100"><span>Data do Pedido</span></div>
                                            <div class="w-100"><span>{{gift.date}}</span></div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="w-100"><span>Total</span></div>
                                            <div class="w-100"><span>{{gift.value}}</span></div>                                        
                                        </div>
                                        <div class="col-md-3">
                                            <div>{{gift.clientName}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="w-100 p-2">
                                        <div class="p-2">
                                            <div v-for="product in gift.items" v-bind:key="product.id" class="float-left w-100">
                                                <div class="w-100 pb-2 pt-2">
                                                    <div class="d-inline-block w-25">
                                                        <img class="mw-100" :src="product.imageUrl" />
                                                    </div>
                                                    <div class="d-inline-block w-75 pl-2">
                                                        <span class="mb-1"><strong>{{product.name}}</strong></span>
                                                        <br />
                                                        <span class="mt-0 mb-2">
                                                            <span class="pr-3"><span>{{product.quantity}}</span> un</span>
                                                            <span>{{product.price}}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-100 p-2">
                                        <textarea readonly style="background-color:#fff6e0;border-color: #ffe6e6;" class="p-2 rounded w-100" rows="5" v-model="gift.note"></textarea>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
				</div>				
			</div>			
		</div>
		
  </Layout>
</template>

<style>


.ext {
    text-align: center
}

.int {
    margin: 0 auto;
    text-align: left;
    position: relative;
    width: 1170px
}

.centered-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

